<template>
<div class="m-content">
        <MenuViews></MenuViews>

        <div class="m-portlet m-portlet--mobile">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">{{ labels.view_roles | capitalize }} {{ hits.length ? `(${ hits.length } ${labels.products})` : '' }}</h3>
        </div>
      </div>

      <div class="m-portlet__head-tools">
        <ul class="m-portlet__nav">
          <li class="m-portlet__nav-item">
              <button
                @click="exportExcel()"
                type="button"
                class="btn btn-elevate btn-icon-sm btn-pill"
              >
                <i class="la la-download"></i>
                {{ labels.export | capitalize }}
              </button>
          </li>
          <li class="m-portlet__nav-item">
              <button
                tag="button"
                @click="$router.go(-1)"
                class="btn btn-elevate btn-icon-sm btn-pill">{{ labels.return }}</button>
            </li>
        </ul>
      </div>
    </div>
    <div class="m-portlet__body">
        <TableWithFilter
          :rawData="rawData"
          :fields="fields"
          :viewlabels="labels.exportRoleView"
          :facetFilters="searchParameters ? searchParameters.facetFilters : []">
        </TableWithFilter>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import * as algoliasearch from 'algoliasearch';
import TableWithFilter from '../../Table/TableWithFilter.vue';
import MenuViews from '../MenuViews.vue';
import exportRoleView from '../../../assets/js/exportRoleView';

const client = algoliasearch(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_SEARCH_KEY,
);
const productIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_products`);

export default {
  name: 'RolesTable',
  components: {
    TableWithFilter,
    MenuViews,
  },
  data() {
    return {
      hits: [],
      rawData: null,
      rolesStats: {},
      query: '',
      searchParameters: null,
      browseObject: null,
      fields: [
        {
          id: 'roles',
          orderable: true,
          searchType: 'text',
          filterName: 'roles',
          orderData: [0],
          facetFilters: 'rolesMix.name',
          width: '200px',
        },
        {
          id: 'numberInProduct',
          orderable: true,
          searchType: false,
          filterName: 'segmentationParents',
          orderData: [1, 0],
          width: '100px',
        },
        {
          id: 'percentageShow',
          orderable: true,
          searchType: false,
          filterName: 'percentageShow',
          orderData: [2, 0],
          width: '100px',
        },
        {
          id: 'modeActions',
          orderable: false,
          searchType: 'text',
          filterName: 'modeActions',
          facetFilters: 'modeActions',
          width: '200px',
        },
        {
          id: 'ingredients',
          orderable: false,
          searchType: 'text',
          filterName: 'ingredients',
          facetFilters: 'ingredientsMix.name',
          width: '280px',
        },
        {
          id: 'numberInPatent',
          orderable: true,
          searchType: false,
          filterName: 'numberInPatent',
          orderData: [5, 0],
          width: '100px',
        },
        {
          id: 'themes',
          orderable: false,
          searchType: 'text',
          filterName: 'themes',
          facetFilters: 'themes',
        },
        {
          id: 'parentSegmentations',
          orderable: false,
          searchType: 'text',
          filterName: 'parentSegmentations',
          facetFilters: 'parentSegmentation',
        },
        {
          id: 'subSegmentations',
          orderable: false,
          searchType: 'text',
          filterName: 'subSegmentations',
          facetFilters: 'subSegmentation',
          width: '700px',
        },
      ],
    };
  },
  mixins: [exportRoleView],
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      selectedProductIds: (store) => store.products.selectedProductIds,
      allSelected: (store) => store.products.allSelected,
      lastSearch: (store) => store.products.lastSearch,
      previewURL: (store) => store.products.previewURL,
    }),
  },
  methods: {
    run() {
      this.hits = [];
      this.rolesStats = [];
      this.browse();
    },
    initBrowseObject() {
      let myfacetFilters = [];
      if (this.searchParameters.facetFilters) {
        myfacetFilters = [...this.searchParameters.facetFilters];
      }
      myfacetFilters.push(['hasClaims:true', 'hasClaims:false']);
      // const restrictSearchableAttributes = JSON.parse(
      //   this.searchParameters.restrictSearchableAttributes,
      // );
      const restrictSearchableAttributes = '';

      this.browseObject = {
        facetFilters: myfacetFilters,
        restrictSearchableAttributes,
      };
    },
    browse() {
      const browser = productIndex.browseAll(
        this.query,
        this.browseObject,
      );
      const my = this;
      browser.on('result', (content) => {
        my.hits = my.hits.concat(content.hits);
      });

      browser.on('end', () => {
        console.log('We got %d hits', my.hits.length);
        this.startStats();
        this.rawData = this.transformObjectToArrayV2(this.rolesStats);
      });

      browser.on('error', (err) => {
        throw err;
      });
    },
    startStats() {
      const my = this;

      this.hits.forEach((hit) => {
        const rolesInThisHit = [];
        const currentRolesInProduct = [];

        // ingredients inside product
        if (hit.ingredientsV2) {
          hit.ingredientsV2.forEach((ingredient) => {
            if (ingredient.roles) {
              ingredient.roles.forEach((role) => {
                this.addRoleIfNotYet(role.name);
                // check if we didn't count this role already for this product
                if (currentRolesInProduct.indexOf(role.name) === -1) {
                  currentRolesInProduct.push(role.name);
                }

                this.rolesStats[role.name].ingredients = this.addRoleStats(
                  this.rolesStats[role.name].ingredients,
                  [ingredient.name],
                );

                this.rolesStats[role.name].modeActions = this.addRoleStats(
                  this.rolesStats[role.name].modeActions,
                  [role.modeAction],
                );
                this.generalStatPerHit(rolesInThisHit, role.name, hit);
                this.updatePercentage(role.name);
              });
            }
          });
        }

        // ingredient inside patent
        if (hit.patentsV2) {
          const currentRoleInPatent = [];
          hit.patentsV2.forEach((patent) => {
            patent.roles.forEach((role) => {
              this.addRoleIfNotYet(role.name);
              // check if we didn't count this ingredient already for this product (in other patent)
              if (currentRoleInPatent.indexOf(role.name) === -1) {
                currentRoleInPatent.push(role.name);
                my.rolesStats[role.name].numberInPatent += 1;
              }

              this.rolesStats[role.name].modeActions = this.addRoleStats(
                this.rolesStats[role.name].modeActions,
                [role.mode_action_name],
              );
              this.generalStatPerHit(rolesInThisHit, role.name, hit);
              this.updatePercentage(role.name);
            });
          });
        }
      });
    },
    updatePercentage(role) {
      // actualise the percentage
      this.rolesStats[role].percentageShow = this.rolesStats[role].numberInProduct
        ? this.rolesStats[role].numberInProduct
                / this.hits.length
        : 0;
    },
    addRoleIfNotYet(role) {
      if (!Object.prototype.hasOwnProperty.call(this.rolesStats, role)) {
        this.rolesStats[role] = {
          name: role,
          numberInProduct: 0,
          numberInPatent: 0,
          percentageShow: 0,
          modeActions: [],
          ingredients: [],
          themes: [],
          parentSegmentations: [],
          subSegmentations: [],
        };
      }
    },
    addRoleStats(elemStats, elems) {
      const stats = elemStats;
      if (elems) {
        const temp = [];
        elems.forEach((elem) => {
          if (temp.indexOf(elem) === -1) {
            temp.push(elem);
            if (
              !Object.prototype.hasOwnProperty.call(stats, elem)
            ) {
              stats[elem] = 0;
            }
            stats[elem] += 1;
          }
        });
      }

      return stats;
    },
    generalStatPerHit(rolesInThisHit, role, hit) {
      if (rolesInThisHit.indexOf(role) === -1) {
        rolesInThisHit.push(role);
        this.rolesStats[role].numberInProduct += 1;
        this.rolesStats[role].themes = this.addRoleStats(
          this.rolesStats[role].themes,
          hit.themes,
        );
        this.rolesStats[role].parentSegmentations = this.addRoleStats(
          this.rolesStats[role].parentSegmentations,
          hit.parentSegmentation,
        );
        this.rolesStats[role].subSegmentations = this.addRoleStats(
          this.rolesStats[role].subSegmentations,
          hit.subSegmentation,
        );
      }
    },
    exportExcel() {
      this.exportRoleView(this.rolesStats, this.hits.length);
    },
    createParams(params) {
      try {
        const searchParameters = {
          attributesToRetrieve: ['productId'],
        };
        params.forEach((param) => {
          const splitParam = param.split('=');
          const key = decodeURIComponent(splitParam[0]);
          const value = decodeURIComponent(splitParam[1]);

          if (key === 'hitsPerPage') {
            searchParameters[key] = 1000;
          } else if (key === 'page') {
            searchParameters[key] = 0;
          } else {
            searchParameters[key] = value;
          }
        });
        searchParameters.facetFilters = (searchParameters.facetFilters) ? JSON.parse(searchParameters.facetFilters) : [];

        return searchParameters;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    setSearchParameter() {
      if (this.previewURL.length) {
        // Get the last result object
        const lastResult = this.previewURL[0];
        if (lastResult) {
          this.query = lastResult.query;

          const queryArray = lastResult.params.split('&');
          this.searchParameters = this.createParams(queryArray, 0);
        }
      }
    },
    goToIngredientsView() {
      this.$router.push({ name: 'IngredientsTable' });
    },
    goToRolesView() {
      this.$router.push({ name: 'RolesTable' });
    },
    goToRelatedIncisView() {
      this.$router.push({ name: 'RelatedIncisTable' });
    },
  },
  mounted() {
    this.setSearchParameter();
    this.initBrowseObject();
    this.run();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Products/Roles/RolesTable.vue